import{transformProp}from"./prop.js";









export const recurseArray=({
array,
changes,
ancestors,
path,
size,
maxSize,
recurse
})=>{
const newArray=[];

let state={empty:true,size};

for(let index=0;index<array.length;index+=1){
state=transformProp({
parent:array,
changes,
ancestors,
path,
maxSize,
key:index,
type:"arrayItem",
empty:state.empty,
size:state.size,
recurse
});

if(state.value!==undefined){

newArray.push(state.value)
}
}

return{value:newArray,size:state.size}
};